export default "__VITE_ASSET__CU5orckd__"